import { ITimestampResponse } from '@/types/common';
import { Moment } from 'moment';
import { IArticle } from '../article';
import { IOffer } from '../offer';
import { Status } from '@/utils';

export enum BannerSourceType {
  ARTICLE = 'article',
  OFFER = 'offer',
}

export const bannerSourceTypeJP: Record<BannerSourceType, string> = {
  [BannerSourceType.ARTICLE]: '記事',
  [BannerSourceType.OFFER]: 'オファー',
};

export interface IBanner extends ITimestampResponse {
  displayOrder: number;
  url: string;
  status: Status;
  startAt: Moment;
  endAt: Moment;
  image: any;
  sourceType?: BannerSourceType;
  sourceId?: number;
  article?: IArticle;
  offer?: IOffer;
  id: number;
}

export interface IGetListBannerResponse extends IBanner {}

export interface IGetDetailBannerResponse extends IBanner {}
